module.exports = __webpack_public_path__ + "static/media/Quick.c5be81a7.svg";